const ModalOrderPlan = {
  PlanningIndex: "0",
  PlanningPk: "",
  PlanningFk: "",
  PlanningOriginCountryCode: "",
  PlanningDestinationCountryCode: "",
  PlanningOriginPortCode: "",
  PlanningDestinationPortCode: "",
  PlanningContainerNumbers: "",
  PlanningCutOfDate: "",
  PlanningVoyage: "",
  PlanningVessel: "",
  PlanningEstimatedDepart: "",
  PlanningEstimatedArrival: "",
  PlanningOriginCountryName: { Code: "", Description: "" },
  PlanningDestinationCountryName: { Code: "", Description: "" },
  PlanningOriginPortName: {
    Code: "",
    PortName: "",
    Lat: "",
    Lng: "",
  },
  PlanningDestinationPortName: {
    Code: "",
    PortName: "",
    Lat: "",
    Lng: "",
  },
  PlanningMasterBill: "",
  PlanningCarrierCode: { OrgCode: "" },
  PlanningCarrierPK: "",
  PlanningSendingAgentPK: "",
  PlanningSendingAgentCode: { OrgCode: "" },
  PlanningReceivingAgentCode: { OrgCode: "" },
  PlanningReceivingAgentPK: "",
  PlanningFinalDestination: { Code: "", Description: "" },
  PlanningForwarderCarrier: { value: "", id: "" },
  PlanningRates: "",
  PlanningOrderReadyDate: "",
  IsFreezed: false,
  OrderPlanningContainerCollection: [],
  OrderPlanningContainerRatesCollection: [],
};

export default ModalOrderPlan;
